import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DrawerModule } from 'primeng/drawer';
import { SHARED_IMPORTS } from 'src/app/utils/other/standalone-import';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: true,
  imports: [SHARED_IMPORTS, DrawerModule]
})
export class SidebarComponent {
  @Input() sidebarVisible = false;

  @Output() sidebarVisibleChange = new EventEmitter<boolean>();

  onVisibleChange(visible: boolean) {
    this.sidebarVisibleChange.emit(visible);
  }
}
